import React from "react";

const AlertBanner = ({ type = "info", children }) => (
  <div className={`alert-banner ${type}`}>
    <span className="alert-icon">
      {type === "warning" ? "⚠️" : type === "success" ? "✅" : "ℹ️"}
    </span>
    <div>{children}</div>
  </div>
);

export default AlertBanner;
